module.exports = __webpack_public_path__ + "img/forward_together.0fde9211.png";